module.exports = __webpack_public_path__ + "static/media/29.e3e5fde5.png";